import React from "react";
import APIautomationContent from "../function-components/learningCourses/APIautomationContent";

function APIautomation() {
  return (
    <>
      <APIautomationContent />
    </>
  );
}

export default APIautomation;
